import { Delete } from 'lucide-react'

/**
 * NumPad — a big-button numeric keypad. Solves the headline complaint about
 * the old PWA ("you can't enter the quantity yourself") with thumb-sized keys
 * and no reliance on the OS keyboard (which on a phone covers the very total
 * the cashier is trying to read).
 *
 *   value     the current string (controlled)
 *   onChange  (nextString) => void
 *   decimal   allow a single "." with up to 2 dp (for cash tender). Default false.
 *
 * Leading-zero and double-dot guards keep the string clean ("0" + 5 → "5",
 * "12." + "." ignored, "1.999" capped at "1.99").
 */
export default function NumPad({ value, onChange, decimal = false }) {
  const press = (k) => {
    let v = String(value ?? '')

    if (k === 'del') { onChange(v.slice(0, -1)); return }

    if (k === '.') {
      if (!decimal || v.includes('.')) return
      onChange(v === '' ? '0.' : v + '.')
      return
    }

    // Cap to 2 decimal places once a point exists.
    if (decimal && v.includes('.')) {
      const dp = v.split('.')[1] || ''
      if (dp.length >= 2) return
    }
    // Avoid a leading zero ("0" + "5" → "5", but keep "0." intact).
    if (v === '0') v = ''

    onChange(v + k)
  }

  const keys = ['1', '2', '3', '4', '5', '6', '7', '8', '9', decimal ? '.' : '', '0', 'del']

  return (
    <div className="grid grid-cols-3 gap-2.5">
      {keys.map((k, i) =>
        k === '' ? (
          <div key={i} />
        ) : (
          <button
            key={i}
            type="button"
            onClick={() => press(k)}
            className={`h-14 rounded-2xl grid place-items-center text-2xl font-bold tabular-nums select-none transition-colors ${
              k === 'del'
                ? 'bg-sage-100 ring-1 ring-sage-200 text-sage-500 active:bg-sage-200'
                : 'bg-white ring-1 ring-sage-200 text-sage-900 shadow-[0_1px_0_rgba(15,31,23,0.05)] active:bg-brand-50 active:ring-brand-200'
            }`}
          >
            {k === 'del' ? <Delete size={22} /> : k}
          </button>
        )
      )}
    </div>
  )
}
